import React, { useEffect, useState } from "react";
import PageHeader from "../../../PageHeader";
import BodyPartTableWrapper from "./BodyPartTableWrapper";
import Swal from "sweetalert2";
import BodyEditModal from "./BodyEditModal";
import useAxios from "../../../../api/useAxios";

const BodyPartList = () => {
  const instance = useAxios();
  const [data, setData] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);

  const handleClose = (response) => {
    setOpenEdit(false);
    setSelectedItem(null);
    if (response) {
      const updatedData = data.map((item) => {
        if (item._id === response._id) {
          return response;
        }
        return item;
      });
      setData(updatedData);
    }
  };

  const handleOpenEdit = (item) => {
    setSelectedItem(item);
    setOpenEdit(true);
  };

  useEffect(() => {
    const getBodyParts = async () => {
      try {
        const response = await instance.get("/body-parts");
        setData(response.data.data);
      } catch (error) {
        Swal.fire({
          title: "Error",
          text: "Something Went Wrong",
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      }
    };

    getBodyParts();
  }, []);
  return (
    <>
      <PageHeader title={"Body Part List"} />
      <BodyPartTableWrapper data={data} handleOpenEdit={handleOpenEdit} />;
      {selectedItem && (
        <BodyEditModal
          selectedItem={selectedItem}
          open={openEdit}
          handleClose={handleClose}
        />
      )}
    </>
  );
};

export default BodyPartList;
